import React from 'react';
import { motion } from 'framer-motion';
interface StartStreamingScreenProps {
  onStart: () => void;
}
export function StartStreamingScreen({
  onStart
}: StartStreamingScreenProps) {
  return <div className="relative w-full h-screen overflow-hidden" data-id="element-638">
      {/* Background */}
      <div className="absolute inset-0" data-id="element-639">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior background" className="w-full h-full object-cover blur-md" data-id="element-640" />
        <div className="absolute inset-0 bg-white/40" data-id="element-641" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full" data-id="element-642">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl shadow-2xl p-12 border-2 border-cyan-400" data-id="element-643">
          <button onClick={onStart} className="px-12 py-4 bg-white border-2 border-black text-black font-medium text-lg rounded-lg hover:bg-gray-50 transition-colors uppercase tracking-wider" data-id="element-644">
            Start Streaming
          </button>
        </motion.div>
      </div>
    </div>;
}